module.exports = __webpack_public_path__ + "static/img/gaolan.7c54b96a.png";